export default "__VITE_ASSET__01Cqs1gE__"